module.exports = "<principal></principal>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Apache24/htdocs/ostimar/frontend/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main